module.exports = __webpack_public_path__ + "static/media/textTaskIcon.8d3632e4.svg";